var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10948_67350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.165C15.0617 19.165 19.165 15.0617 19.165 9.99996C19.165 4.93827 15.0617 0.834961 9.99996 0.834961C4.93827 0.834961 0.834961 4.93827 0.834961 9.99996C0.834961 15.0617 4.93827 19.165 9.99996 19.165Z",
    fill: "url(#paint0_linear_10948_67350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
    fill: "#D7FF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 10.6316V11.9667C6.98242 12.9666 7.793 13.7772 8.79297 13.7772H13.0176V13.576C13.0176 12.5761 12.207 11.7655 11.207 11.7655H8.79297C7.99673 11.7655 7.30854 11.3027 6.98242 10.6316Z",
    fill: "#25143B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99414 11.5643V7.54089C8.99414 6.54093 8.18356 5.73035 7.18359 5.73035H6.98242V9.75378C6.98242 10.7537 7.793 11.5643 8.79297 11.5643H8.99414Z",
    fill: "#25143B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10948_67350",
    x1: 0.5,
    y1: 0.999023,
    x2: 19,
    y2: 18.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DAF460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EA9067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#51327B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10948_67350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaos);
export default __webpack_public_path__ + "static/media/laos.abe1b3cbd8e93fdee6781239eaada019.svg";
export { ForwardRef as ReactComponent };